<template>
    <div name="banner" class="banner">
        <div ref="slider" class="slider" @touchstart="startTouch" @touchend="endTouch"  @touchmove="moveTouch" @wheel="handleScroll">
            <div v-for="section in sections" :key="section.id" class="section" :class="section.class">
                <div class="title-area">
                <strong class="title">
                    {{ section.title }}
                </strong>
                <p class="sub-text" v-html="section.subText">
                </p>
                </div>
                <img class="img" :src="section.imgSrc" :alt="section.imgSrcAlt">
            </div>
        </div>
        <img class="banner-mouse" src="../../assets/mobile_barocare/img_mouse_arrow.png" alt="마우스 스크롤">
    </div>
</template>

<script>

export default {
    name: 'banner',
    data() {
        return {
            sections: [
                {
                    id: 1,
                    class: 'section1',
                    title: '바로돌봄',
                    subText: '의료취약계층을 위한<br> 국내 유일 비대면진료 솔루션',
                    imgSrc: require('../../assets/mobile_barocare/bg_image1.jpg'),
                    imgSrcAlt: '의료취약계층을 위한 국내 유일 비대면진료 솔루션'
                },
                {
                    id: 2,
                    class: 'section2',
                    title: '바로돌봄',
                    subText: '정신병원, 요양원, 주야간돌봄센터 등<br> 어르신을 케어하는 기관에 도입할 수 있습니다',
                    imgSrc: require('../../assets/mobile_barocare/bg_image2.jpg'),
                    imgSrcAlt: '정신병원, 요양원, 주야간돌봄센터 등 어르신을 케어하는 기관에 도입할 수 있습니다'
                },
                {
                    id: 3,
                    class: 'section3',
                    title: '바로돌봄',
                    subText: '바로돌봄으로 보다<br> 편하고 안전하게 의료진을 만나보세요',
                    imgSrc: require('../../assets/mobile_barocare/bg_image3.jpg'),
                    imgSrcAlt: '바로돌봄으로 보다 편하고 안전하게 의료진을 만나보세요'
                },
            ],
            currentIndex: 0,
            startY: 0,
            endY: 0,
            scrolling: false,
        };
    },
    mounted() {
        document.addEventListener('touchmove', this.moveTouch, { passive: false });
    },
    beforeDestroy() {
        document.removeEventListener('touchmove', this.moveTouch);
    },
    methods: {
        startTouch(event) {
            // console.log("startTouch triggered");
            this.startY = event.touches[0].clientY;
        },
        moveTouch(event) {
            var moveY = event.touches[0].clientY;
            var diff = this.startY - moveY;

            // 마지막 슬라이드에서 아래로 스크롤
            if (this.currentIndex === this.sections.length - 1 && diff > 0) {
                // console.log("This should allow native scroll.");
                return;
            }
            if ((this.currentIndex === 0 || this.currentIndex === 1) && diff < 0) {
                return;
            }

            event.preventDefault();
        },
        endTouch(event) {
            this.endY = event.changedTouches[0].clientY;
            var diff = this.startY - this.endY;
            if (diff > 50) {
                // 위로 스크롤
                if (this.currentIndex < this.sections.length - 1) {
                this.currentIndex = Math.min(this.currentIndex + 1, this.sections.length - 1);
                this.updateSlider();
                }
            } else if (diff < -50) {
                // 아래로 스크롤
                if (this.currentIndex > 0) {
                this.currentIndex = Math.max(this.currentIndex - 1, 0);
                } else {}
                this.updateSlider();
            }
        },
        handleScroll(event) {
            if (this.scrolling) return;

            this.scrolling = true;
            setTimeout(() => {
                this.scrolling = false;
            }, 400);

            if (event.deltaY > 0 && this.currentIndex < this.sections.length - 1) {
            // 위로 스크롤
                event.preventDefault();
                this.currentIndex = Math.min(this.currentIndex + 1, this.sections.length - 1);
            } else if (event.deltaY < 0 && this.currentIndex > 0) {
                // 아래로 스크롤
                event.preventDefault();
                this.currentIndex = Math.max(this.currentIndex - 1, 0);
            } else if (event.deltaY < 0 && this.currentIndex === 0) {}
            this.updateSlider();
        },
        updateSlider() {
            var slider = this.$refs.slider;
            slider.style.transform = `translateY(-${this.currentIndex * 100}vh)`;

            var titleAreas = document.querySelectorAll('.title-area');
    
            titleAreas.forEach((titleArea) => {
                titleArea.classList.remove('fadeInUp');
                void titleArea.offsetWidth;
                titleArea.classList.add('fadeInUp');
            });
        },
    },
}
</script>

<style scoped>
    .banner {
        position: relative;
        width: 100%;
        /* height: 720px; */
        height: 100vh;
        height: 100dvh;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        z-index: 0;
    }
    .title-area{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        padding-top: 0px;
        z-index: 10;
        font-family: 'Pretendard';
        font-style: normal;
        text-align: center;
        /* animation: fadeInUp1 1s; */
    }
    .fadeInUp {
        animation: fadeInUp1 1s;
    }
    .title {
        font-weight: 600;
        font-size: 50px;
        line-height: 68px;
        color: #fff;
    }
    .sub-text{
        margin-top: 10px;
        font-size: 18px;
        font-weight: 400;
        line-height: 1.6;
        color: #fff;
    }
    .image-slider {
        position: relative;
        width: 100%;
        height: 720px;
        overflow: hidden;
    }
    .image-container {
        display: flex;
        position: relative;
        width: 100%;
        height: 100%;
        overflow: hidden;
    }
    .image-container img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 720px;
        background-color: #1A1A1A;
        background-position: center center;
        background-size: auto 720px;
        background-repeat: no-repeat;
        opacity: 0;
        transition: opacity 1.2s;
        object-fit: contain;
    }
    .image-item.active {
        opacity: 1;
    }
    .banner-mouse{
        position: absolute;
        left: 50%;
        bottom: 26px;
        transform: translate(-50%);
        display: block;
        width: 24.337px;
        height: 60.017px;
        z-index: 20;
    }
    .section{
        position: relative;
        display: block;
        width: 100%;
        /* height: 100%; */
        height: 100dvh;
        height: 100vh;
        overflow: hidden;
    }
    .section .img{
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .slider {
        transition: transform 0.3s ease-in-out;
    }
    @keyframes fadeInUp1 {
        0% {
            opacity: 0;
            transform: translate3d(-50%, 100%, 0);
        }
        to {
            opacity: 1;
            transform: translate3d(-50%, -50%, 0);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/mobile_barocare/Banner.vue